import React from "react";
import ReactDOM from "react-dom/client";
import './components/FeaturesSection.module.css'
import App from "./App";
import'./components/Navbar.css';

// ✅ Global styles
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
















/*
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
*/

